export default "__VITE_ASSET__8312afa8__"